import React, { useEffect, useState } from "react";
import {
  Route,
  Switch,
  Redirect,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import { connect } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import PageWrapper from "../PageWrapper";
import SubNavbar from "../../components/Navbar/SubNavbar";
import ButtonBlue from "../../components/Button/ButtonBlue";

import Feed from "./Feed";
import Group from "./Group";
import Shared from "./Shared";
import SharePost from "./SharePost";
import VideoGallery from "./VideoGallery";

import {
  showSharepost,
  hideSharepost,
  hideShareto,
} from "../../redux/actions/sharePost";
import ShareTo from "./ShareTo";
import AnnounceEditor from "./AnnounceEditor";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import ShowcaseGallery from "./ShowcaseGallery";
import { ButtonCommonTopNew } from "../Theme";
import { HiShare } from "react-icons/hi";
import { getCommunitySubMenus } from "../../redux/actions/auth";

const CommunityPages = (props) => {
  const { path } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();
  const [count, setCount] = useState(0);
  const community_submenu = useSelector(
    (state) => state.auth.community_submenu
  );

  useEffect(() => {
    return () => {
      props.hideSharepost();
      props.hideShareto();
    };
  }, []);

  useEffect(() => {
    dispatch({
      type: "feedFilter",
      payload: null,
    });
    dispatch({
      type: "groupFilter",
      payload: null,
    });
    axios.get(serverUrl.SharedCommentCount).then((res) => {
      if (res.status === 200) {
        setCount(res.data.shared_reflection_Count);
      }
    });
  }, []);
  const isVideoGallery =
    useRouteMatch({
      path: `/community/videogallery`,
      strict: false,
      sensitive: false,
    }) !== null;

  const isShared =
    useRouteMatch({
      path: `/community/shared`,
      strict: false,
      sensitive: false,
    }) !== null;

  useEffect(() => {
    axios.get(serverUrl.SharedCommentCount).then((res) => {
      if (res.status === 200) {
        setCount(res.data.shared_reflection_Count);
      }
    });
  }, [isShared]);
  return (
    <PageWrapper>
      <div className="cardBackgroundColor border20px shadow-sm">
        {location.pathname !== `${path}/addannouncement` &&
          !location.pathname.includes(`${path}/editannouncement`) && (
            <SubNavbar
              menuLinks={[
                ...(community_submenu?.communityMenus?.map((item) => ({
                  title: item.lookup_name,
                  url: `/${item.lookup_value}`,
                  count: item.lookup_name == "Shared" ? count : null,
                })) || []),
              ]}
              aside={
                !isVideoGallery && (
                  <ButtonCommonTopNew
                    className="flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer"
                    id="hideDropDown"
                    onClick={props.showSharepost}
                  >
                    <HiShare
                      fontSize="small"
                      className="w-4 h-4 cursor-pointer primaryIcon"
                    />
                    Share Post
                  </ButtonCommonTopNew>
                )
              }
            />
          )}
        <Switch>
          <Route exact path="/community">
            {community_submenu?.communityMenus?.length > 0 &&
              (community_submenu.communityMenus.some(
                (item) => item.lookup_name.toLowerCase() === "feed"
              ) ? (
                <Feed />
              ) : (
                <Redirect
                  to={`/${community_submenu.communityMenus[0].lookup_value}`}
                />
              ))}
          </Route>
          {/* Showcase Gallery */}
          {community_submenu?.communityMenus?.some(
            (s) => s.lookup_value.toLowerCase() === "community/showcasegallery"
          ) && (
            <Route
              path={`${path}/showcasegallery`}
              component={ShowcaseGallery}
            />
          )}

          {/* Shared */}
          {community_submenu?.communityMenus?.some(
            (s) => s.lookup_value.toLowerCase() === "community/shared"
          ) && <Route path={`${path}/shared`} component={Shared} />}

          {/* Video Gallery */}
          {community_submenu?.communityMenus?.some(
            (s) => s.lookup_value.toLowerCase() === "community/videogallery"
          ) && <Route path={`${path}/videogallery`} component={VideoGallery} />}

          {/* Groups + Announcements */}
          {community_submenu?.communityMenus?.some(
            (s) => s.lookup_value.toLowerCase() === "community/groups"
          ) && (
            <>
              <Route path={`${path}/groups`} component={Group} />
              <Route
                path={`${path}/addannouncement`}
                component={AnnounceEditor}
              />
              <Route
                path={`${path}/editannouncement/:id`}
                component={AnnounceEditor}
              />
            </>
          )}
          <Redirect
            to={{
              pathname: "/page-not-found",
              state: { error: true },
            }}
          />
        </Switch>
        <SharePost />
        <ShareTo />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    show: state.showsharepost.show,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showSharepost: () => dispatch(showSharepost()),
    hideSharepost: () => dispatch(hideSharepost()),
    hideShareto: () => dispatch(hideShareto()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommunityPages);
